import { PowerSocketAuIcon } from './PowerSocketAuIcon';

/**
 * author: GreenTurtwig
 * id CFCF8409-65AC-4E1C-885B-107F9D8B4413
 * name power-socket-au
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-au.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketPapuaNewGuineaIcon = PowerSocketAuIcon;
export default PowerSocketPapuaNewGuineaIcon